import Vue from 'vue';

const checkout = {
  state: {
    radix: 10,
    total: 0,
    items: [],
  },
  mutations: {
    ADD_ITEM_CHECKOUT: (state, data) => {
      Vue.set(state, 'items', data);
    },
    UPDATE_STATE_CHECKOUT: (state) => {
      let total = 0;
      state.items.forEach((item) => {
        total += parseInt((item.quantity * item.item.unitPrice), state.radix);
      });

      Vue.set(state, 'total', total);
    },
    REMOVE_ITEM_CHECKOUT: (state) => {
      Vue.set(state, 'items', []);
    },
  },
  actions: {
    addToCheckout({ commit }, item) {
      commit('ADD_ITEM_CHECKOUT', item);
      commit('UPDATE_STATE_CHECKOUT');
    },
    removeToCheckout({ commit }) {
      commit('REMOVE_ITEM_CHECKOUT');
      commit('UPDATE_STATE_CHECKOUT');
    },
  },
  getters: {
    itemsCheckoutInfo: state => state.items,
    totalCheckoutInfo: state => state.total,
  },
};

export default checkout;



// WEBPACK FOOTER //
// ./src/store/modules/buyer/checkout.js